module.exports = __webpack_public_path__ + "static/media/concert2.3d22b26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/concert2.jpg
// module id = 1264
// module chunks = 0